import { FeatureCollection, Polygon, MultiPolygon, Point } from "geojson";

export interface GeoPreviewMapProps {
	inputData: import("../../../../../../utilities/types").GroupedGeoJSON[];
	groupIndex: number;
}

export interface FeaturePopupData {
	lngLat: { lng: number; lat: number };
	properties: Record<string, unknown>;
}

export interface ProcessedFeatureData {
	polygonFC: FeatureCollection<Polygon | MultiPolygon>;
	pointFC: FeatureCollection<Point>;
	totalFeatures: number;
	bounds: [number, number, number, number] | null; // [sw_lng, sw_lat, ne_lng, ne_lat]
	propertiesIndex: Map<string, Record<string, unknown>>;
}

export interface GeoPreviewMapViewModel {
	// State
	activePopup: FeaturePopupData | null;

	// Computed values
	processedFeatures: ProcessedFeatureData;

	// Handlers
	onFeatureClick: (lngLat: { lng: number; lat: number }, properties: Record<string, unknown>) => void;
	handleMapClick: () => void;
}

// Constants
export const WARNING_THRESHOLD = 200;
export const MAX_FEATURES = 500;

export const COLORS = ["#2196F3", "#4CAF50", "#FF9800", "#9C27B0", "#E91E63", "#00BCD4", "#FF5722", "#795548"];
